import { Modal } from "react-bootstrap";
import DOMPurify from "dompurify";
import classes from "./helpCenter.module.scss";
const QuestionView = ({ closeViewModal, show, data }) => {
	const _sanitize = DOMPurify.sanitize;
	return (
		<Modal show={show} onHide={closeViewModal} backdrop="static" size="lg">
			<Modal.Header closeButton>
				<Modal.Title>{data.title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div
					className={`${classes.base_ckeditor}`}
					md="12"
					dangerouslySetInnerHTML={{
						__html: DOMPurify.sanitize(data.description, {
							ADD_TAGS: ["iframe"],
						}),
					}}
				/>
			</Modal.Body>
		</Modal>
	);
};

export default QuestionView;
